/**
 * Frontend Service Registry
 * Mirrors the backend registry pattern for decoupled communication.
 */

class ServiceRegistry {
    constructor() {
        this.registry = {};
        this.listeners = {};
    }

    /**
     * Register a service/action
     * @param {string} name - Unique name (e.g., 'helpdesk.open_ticket')
     * @param {function} handler - Function to execute
     * @param {object} metadata - Optional metadata
     */
    register(name, handler, metadata = {}) {
        if (this.registry[name]) {
            console.warn(`Service ${name} overrides an existing registration.`);
        }
        this.registry[name] = { handler, metadata };

    }

    /**
     * Execute a registered service
     * @param {string} name - Service name
     * @param {*} params - Parameters to pass to handler
     */
    async execute(name, params = {}) {
        const service = this.registry[name];
        if (!service) {
            console.error(`Service ${name} not found.`);
            throw new Error(`Service ${name} not found`);
        }
        try {
            return await service.handler(params);
        } catch (error) {
            console.error(`Error executing ${name}:`, error);
            throw error;
        }
    }

    /**
     * Get all registered services (useful for AI to know what it can do on UI)
     */
    getAllServices() {
        return Object.keys(this.registry).map(key => ({
            name: key,
            ...this.registry[key].metadata
        }));
    }
}

// Singleton instance
const registry = new ServiceRegistry();
export default registry;
